import { render } from "./cvView-3.vue?vue&type=template&id=31cbcdfb&scoped=true"
import script from "./cvView-3.vue?vue&type=script&lang=js"
export * from "./cvView-3.vue?vue&type=script&lang=js"

import "./cvView-3.vue?vue&type=style&index=0&id=31cbcdfb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cbcdfb"]])

export default __exports__